module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notification":{"employee":"Editing is disabled because this application is already completed. You can make changes on \u0027My Profile\u0027 section instead."}}}')
  delete Component.options._Ctor
}
